import React from 'react';
import { View } from 'react-native';
import { useStyleSheet } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
export const Placeholder = ({ style, size, withBack, action }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [
            styles.container,
            styles[size],
            !withBack ? styles.withoutBack : null,
            style
        ] },
        withBack && React.createElement(View, { style: styles.back }),
        withBack ? (React.createElement(View, { style: styles.headline })) : (React.createElement(View, { style: styles.heading })),
        action === 'edit' ? (React.createElement(View, { style: styles.edit })) : action === 'custom' ? (React.createElement(View, { style: styles.controls },
            React.createElement(View, { style: styles.control }),
            React.createElement(View, { style: [styles.control, styles.controlWithMargin] }),
            React.createElement(View, { style: [styles.control, styles.controlWithMargin] }))) : null));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: size.B
    },
    lg: {
        height: 65
    },
    md: {
        height: 61
    },
    withoutBack: {
        justifyContent: 'flex-start',
        paddingLeft: size.C + size.B
    },
    back: {
        width: 39,
        height: 39,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4,
        position: 'absolute',
        left: size.B
    },
    edit: {
        height: 15,
        width: size.L,
        backgroundColor: color.invert2.p4,
        borderRadius: 9999
    },
    controls: {
        flexDirection: 'row',
        position: 'absolute',
        right: size.B
    },
    control: {
        width: 39,
        height: 39,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4
    },
    controlWithMargin: {
        marginLeft: size.C
    },
    headline: {
        height: size.G,
        width: size.P,
        backgroundColor: color.invert2.p4,
        borderRadius: 9999
    },
    heading: {
        height: size.J,
        width: size.P,
        backgroundColor: color.invert2.p4,
        borderRadius: 9999
    }
}));
//# sourceMappingURL=Placeholder.js.map